import axios from 'axios';
import {rootUrl} from './rootUrl.js';
export let memberMessage={
  //  消息通知
  getNoticeList(params) {
    return axios.post(rootUrl + '/memberMessage/getNoticeList', params)
  },
  //  一键已读
  getNoticesAlready(params) {
    return axios.post(rootUrl + '/memberMessage/getNoticesAlready', params)
  },
};



// WEBPACK FOOTER //
// ./src/service/memberMessage.js